import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box radius-7 heigth-other-cards-dashboard" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing radius-7 total-success-card spacing-cards-dashboard" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis font-cards-dashboard" }, "Uploads com sucesso", -1)
const _hoisted_4 = { class: "fw-black mb-12 lh-1 font-size-32" }
const _hoisted_5 = { class: "mt-15 mt-md-25 mb-8 mb-md-12 d-flex justify-content-between align-items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-secondary" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-black" }, "Porcentagem de sucesso")
], -1)
const _hoisted_7 = { class: "text-primary fw-semibold" }
const _hoisted_8 = {
  class: "progress",
  role: "progressbar",
  "aria-valuenow": "68",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.getDashboardDayCards.total_success), 1)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getDashboardDayCards.total_percentage_success) + "%", 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "progress-bar",
            style: _normalizeStyle({ width: _ctx.getDashboardDayCards.total_percentage_success + '%' })
          }, null, 4)
        ])
      ])
    ])
  ]))
}